import { useRef } from 'react'

import { Tag } from 'antd'

import { queryTradeSessionApplyListApi } from '@eastcoal/api/trade/applyMember/queryTradeSessionApplyList'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { RemoteTableStoreRef } from '@eastcoal/common/components/RemoteTable/Store/interface'
import { pick } from '@eastcoal/common/utils/object'

import {
  ApplyStatus,
  ApplyStatusColorMap,
  ApplyStatusEntrustTextMap
} from '@eastcoal/shared/enums/ApplyStatus'
import { getSeatNo } from '@eastcoal/shared/utils/auction'

import { useAuctionListStore } from '../../../Store/hooks/useStore'
import { AuctionModalHeader } from '../ModalHeader'

import { BidMemberTableProps } from './interface'

const columns: BidMemberTableProps['columns'] = [
  {
    dataIndex: 'id',
    title: '席位号',
    align: 'center',
    render: getSeatNo
  },
  {
    dataIndex: 'memberName',
    title: '公司名称'
  },
  {
    dataIndex: 'depositAmount',
    title: '保证金',
    align: 'right',
    valueType: 'digit'
  },
  {
    dataIndex: 'applyTime',
    title: '参与时间',
    align: 'center'
  },
  {
    dataIndex: 'status',
    title: '状态',
    align: 'center',
    render(value: ApplyStatus) {
      return (
        <Tag color={ApplyStatusColorMap[value]} variant='filled'>
          {ApplyStatusEntrustTextMap[value]}
        </Tag>
      )
    }
  }
]

export const BidMemberListModal = () => {
  const {
    currentAuction,
    bidMemberListModalVisible,
    toggleBidMemberListModalVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'currentAuction',
      'bidMemberListModalVisible',
      'toggleBidMemberListModalVisible'
    ])
  )

  const tableRef = useRef<RemoteTableStoreRef>(null)

  const title = (
    <AuctionModalHeader
      desc={currentAuction?.title}
      tableRef={tableRef}
      title='参与人员'
    />
  )

  const auctionId = currentAuction?.id

  return (
    <DraggableModal
      okText='关闭'
      open={bidMemberListModalVisible}
      title={title}
      width={960}
      cancelButtonProps={{
        hidden: true
      }}
      onOpenChange={toggleBidMemberListModalVisible}
    >
      <RemoteTable
        ref={tableRef}
        api={queryTradeSessionApplyListApi}
        columns={columns}
        pagination={false}
        readyRequest={bidMemberListModalVisible && !!auctionId}
        refreshDeps={[bidMemberListModalVisible, auctionId]}
        rowKey='id'
        requestParams={{
          bizId: auctionId
        }}
      />
    </DraggableModal>
  )
}
